import { Settings } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from './Icon.types';

const SettingsIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <Settings width={size} height={size} color={color} {...rest} />;

SettingsIcon.displayName = 'SettingsIcon';

export default SettingsIcon;
